import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useMatch } from "react-router-dom";
import "@/App.css";

import { Cursor } from "@/components/Cursor";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { BackgroundAudio } from "@/components/BackgroundAudio";
import { Splash } from "@/components/Splash";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Episodes from "@/pages/Episodes";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

const SPLASH_SHOWN_KEY = "soultrip_splash_shown_v1";

function Shell() {
  // Show splash once per browser session
  const [splashDone, setSplashDone] = useState(() => {
    try { return sessionStorage.getItem(SPLASH_SHOWN_KEY) === "1"; }
    catch { return false; }
  });

  const handleSplashDone = () => {
    setSplashDone(true);
    try { sessionStorage.setItem(SPLASH_SHOWN_KEY, "1"); } catch (_) { /* ignore */ }
  };

  // If splash is being skipped (already shown), broadcast immediately so Nav reveals
  useEffect(() => {
    if (splashDone) {
      window.dispatchEvent(new CustomEvent("soultrip:splash-done"));
    }
  }, [splashDone]);

  // Admin routes get a minimal shell — no public Nav/Footer/Audio/Splash.
  const isAdmin = !!useMatch("/admin/*");
  if (isAdmin) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/*" element={<AdminLogin />} />
        </Routes>
      </>
    );
  }

  return (
    <>
      {!splashDone && <Splash onDone={handleSplashDone} />}
      <Cursor />
      <Nav />
      <BackgroundAudio />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/episodes" element={<Episodes />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
